app.formContact = {

    settings: {
        formSelector: "#form-contact",
        $form : $("#form-contact")
    },

    init: function() {
        app.formContact.settings.$form.on("submit", app.formContact.submit);
    },

    submit: function(ev){

        ev.preventDefault();

        // $(".form-contact__message").hide();

        app.formContact.settings.$form.find(".btn").removeClass("btn--delta icon--paper-plane btn--dota icon--check").addClass("btn--epsilon icon--spinner").html("Bericht verzenden");

        context.submit({
            method: "submitContactform",
            form: app.formContact.settings.formSelector,
            onSuccess: function(response){

                app.formContact.showSuccess();
                app.formContact.clearForm();
            },
            onError: function(){
                app.formContact.showError();
            }
        });
    },

    showSuccess: function() {
        app.formContact.settings.$form.find(".btn").removeClass("btn--delta icon--paper-plane btn--epsilon icon--spinner").addClass("btn--dota icon--check").html("Succesvol verzonden");
    },

    showError: function() {
        // alert("Uw bericht kon niet verstuurd worden");
    },

    clearForm: function(){
        app.formContact.settings.$form.find("[name=name]").val("");
        app.formContact.settings.$form.find("[name=email]").val("");
        app.formContact.settings.$form.find("[name=city]").val("");
        app.formContact.settings.$form.find("[name=message]").val("");
    }
};